export default {
    namespaced: true,

    state: () => ({
        reseller: {},
    }),

    mutations: {
        STORE_RESELLER(state, reseller) {
            state.reseller = reseller
        },
    },

    actions: {},
};
